import React, { useState } from "react";
import CourseCard from "../components/CourseCard";
import MnLink from "../components/atoms/MnLink";
import SubHeadingBanner from "../components/organisms/SubHeadingBanner";
import HeadingText from "../components/atoms/HeadingText";
import ContentText from "../components/atoms/ContentText";
import ParaText from "../components/atoms/ParaText";
import useScrollToTop from "../hooks/useScrollToTop";
import course from "../assets/images/courses.avif";
import useTranslate from "../hooks/useTranslate";
import imgMap from "../data/courses";

function Courses() {
  useScrollToTop();
  // State to manage how many courses are visible
  const [visibleCount, setVisibleCount] = useState(3);

  const head2 = useTranslate("coursesPage.section.heading2");
  const contentText = useTranslate("coursesPage.section.contentText");
  const courses = useTranslate("coursesPage.section.courses");

  // Function to handle the "Load More" button click
  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 3); // Show 3 more courses
  };

  return (
    <div className="relative">
      <SubHeadingBanner
        imageSrc={course}
        head1="Home - Courses"
        head2="Courses"
      />
      <section>
        <div className="max-w-6xl mx-auto px-4 items-center pt-12">
          <HeadingText variant="h2">{head2}</HeadingText>

          <ContentText>{contentText}</ContentText>
        </div>
      </section>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center max-w-6xl mx-auto px-4 my-8 py-12">
        {courses.slice(0, visibleCount).map((course) => (
          <div className="flex flex-col h-full" key={course.id}>
            <CourseCard
              title={course.title}
              topics={course.topics.map((topic, index) => (
                <ParaText key={index} className="text-sm">
                  {topic.name}
                </ParaText>
              ))}
              imageUrl={imgMap[course.imageId]}
              courseLink={course.courseLink}
              className="flex-1 flex flex-col justify-between min-h-64"
            />
          </div>
        ))}

        {visibleCount < courses.length && (
          <div
            className="col-span-1 sm:col-span-2 md:col-span-3 flex justify-center mt-8"
            onClick={handleLoadMore}
          >
            <MnLink name="Load more..." />
          </div>
        )}
      </div>
    </div>
  );
}

export default Courses;
